import ReactGA from 'react-ga4';

if (process.env.REACT_APP_GTAG_ID) {
  ReactGA.initialize(process.env.REACT_APP_GTAG_ID);
  ReactGA.send({
    hitType: 'pageview',
    page: window.location.pathname
  });
}
